import { create } from 'zustand';

type WelcomePopupSlice = {
  /**
   * Открыт ли приветственный попап прямо сейчас. Нужен нативному шеллу: шторка разрешений
   * (`PushOnboarding`) показывается сразу после входа, и у новичка в приложении она легла бы
   * поверх онбординга — два модальных потока в первые же секунды. Разрешения ждут, пока человек
   * закроет приветствие; отложить их некуда — второго шанса на запрос система не даёт.
   */
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const useWelcomePopupStore = create<WelcomePopupSlice>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
